/** Create/update payload for a liability. The stable `name` is server-derived, not editable. */
export interface RevisionLiabilityEditModel {
    readonly displayName: string;
    readonly displayOrder: number;
}
